import { mapActions } from "vuex";

export default  {
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
			getDataMultiples:  'crudStore/getDataMultiples',  
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'inactivarFtn' :							
						await this.updateDataPost({ 
							data: { 
								data: [],
								route: 'save_all', 
								tablaPost: ['multiple_servicios'],
								tablaDelete:['multiple_servicios'],
								auditar:true,
								notaDelete: null
							 }
						 }) 
						break;

					}
				}
				await this.save(event.save)
				
				
				let beetween=this.fecha().beetween

				const beetweenInicial = await this.buscarIdb({tabla: 'ultima_conexion', campo: 'id', value: 1}) 
				

				const await0 = this.getDataMultiples({route: 'get_multiples', data: {inicial: beetweenInicial[0].inicial, final: beetween.final}})
				const await1 = this.getDataGet({ route: 'get_listservicios', data: 'servicios'})
				const await2 = this.resetDataIndex()
				const await3 = this.resetGlobal({state: 'openModal'})
				const await4 = this.resetGlobal({state: 'saveConfig/capa'})
				const await5 = this.resetDataForm()
				const await6 = this.saveIdb({ultima_conexion: {id: 1, inicial: beetween.inicial, final: beetween.final }})
				await Promise.all([await0,await1,await2,await3,await4,await5,await6])				
			}
			catch(e){
				console.log(e)
			}			
		}		
	},
}
